import { CodeListModifiedComments } from "app/area/indicator-factors/list/types-store";

export const mapComments = (comments: CodeListModifiedComments[]): CodeListModifiedComments[] =>
  comments.map(comment => ({ ...comment, comments: !!comment.comments.trim() ? comment.comments.trim() : null }));
